module.exports = __webpack_public_path__ + "img/ctrl-pauli-root-stub-down-0.109b655b.svg";